/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const SavingsAlt = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M19 2L19.0016 6.1026C19.716 6.83218 20.2722 7.71744 20.6143 8.70277L23 9V15L20.1436 15.3577C19.3422 16.8209 18.0333 17.9666 16.4538 18.5579L16.1429 21H11.8571L11.612 19H8.5L8.396 18.998L8.14286 21H4.85714L3.51267 18.3905C2.42998 16.2683 1.75909 14.8881 1.5 14.25C1.0735 13.1996 1.00964 12.6876 1.00096 12.0217L1 11C1 8.20735 2.63535 5.79666 5.00064 4.67333L5.00033 6.38925C3.49504 7.37057 2.5 9.06908 2.5 11V11.5C2.5 12.2642 2.6422 13.0064 2.91569 13.6999L3.00753 13.9138C3.16976 14.2745 3.49115 14.9375 3.9717 15.9027L5.18593 18.3169C5.37438 18.689 5.57441 19.083 5.786 19.499H6.82L7.07697 17.4724L8.5 17.5H12.9394L13.184 19.5H14.821L15.0801 17.4704L15.9279 17.1531C17.1621 16.6911 18.1949 15.7932 18.828 14.6372L19.1964 13.9647L21.5 13.676V10.324L19.5033 10.0759L19.1973 9.19484C18.9314 8.42907 18.4975 7.73172 17.9299 7.15212L17.5018 6.71499L17.5 3.5H17C16.2935 3.5 15.6563 3.92479 15.3846 4.57692L15 5.5H12.9998V4H14C14.5046 2.7889 15.688 2 17 2H19ZM17 9C17.5523 9 18 9.44772 18 10C18 10.5523 17.5523 11 17 11C16.4477 11 16 10.5523 16 10C16 9.44772 16.4477 9 17 9ZM11 4V5.5H7V4H11Z"
                        fill={color}
                    />
                </svg>
        );
    };
